import { render, staticRenderFns } from "./OfferFilesTable.vue?vue&type=template&id=ef5f6db8"
import script from "./OfferFilesTable.vue?vue&type=script&lang=js"
export * from "./OfferFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports